import { createSlice } from '@reduxjs/toolkit';

import { DEFAULT_TIMEZONE } from 'constants/timezones';
import { getAppSettingsApi, updateAppTimezoneApi } from './app-settings.api';

const initialState = {
  timezone: DEFAULT_TIMEZONE,
  displayTime: '',
  defaultTimezone: DEFAULT_TIMEZONE,
  loading: false,
  saving: false,
  error: null,
  loaded: false,
};

const appSettingsSlice = createSlice({
  name: 'appSettings',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAppSettingsApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAppSettingsApi.fulfilled, (state, action) => {
        state.loading = false;
        state.loaded = true;
        state.timezone = action.payload?.timezone || DEFAULT_TIMEZONE;
        state.displayTime = action.payload?.displayTime || '';
        state.defaultTimezone = action.payload?.defaultTimezone || DEFAULT_TIMEZONE;
      })
      .addCase(getAppSettingsApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to load app settings';
      })
      .addCase(updateAppTimezoneApi.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(updateAppTimezoneApi.fulfilled, (state, action) => {
        state.saving = false;
        state.timezone = action.payload?.timezone || state.timezone;
        state.displayTime = action.payload?.displayTime || state.displayTime;
      })
      .addCase(updateAppTimezoneApi.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload?.message || 'Failed to update timezone';
      });
  },
});

export default appSettingsSlice.reducer;
